document.addEventListener("DOMContentLoaded", function () {

    // Replace this with your uploaded Shopify image URL
    const flowerURL = "https://cdn.shopify.com/s/files/1/0687/5145/8601/files/Glowing_Crystal_Snowflake_Emblem.png?v=1791871764";

    let lastSpawn = 0;
    const throttle = 50; // milliseconds

    function createFlower(x, y) {

        const now = Date.now();

        if (now - lastSpawn < throttle) return;

        lastSpawn = now;

        const flower = document.createElement("img");

        flower.src = flowerURL;
        flower.className = "marigold";

        const size = 18 + Math.random() * 12;

        flower.style.width = size + "px";
        flower.style.height = "auto";

        flower.style.left = (x - size / 2) + "px";
        flower.style.top = (y - size / 2) + "px";

        flower.style.setProperty(
            "--drift",
            (Math.random() * 60 - 30) + "px"
        );

        flower.style.setProperty(
            "--rotate",
            (Math.random() * 180 - 90) + "deg"
        );

        document.body.appendChild(flower);

        flower.addEventListener("animationend", function () {
            flower.remove();
        });

    }

    // Desktop
    document.addEventListener("mousemove", function (e) {
        createFlower(e.clientX, e.clientY);
    });

    // Mobile Touch
    document.addEventListener("touchmove", function (e) {

        if (!e.touches.length) return;

        createFlower(
            e.touches[0].clientX,
            e.touches[0].clientY
        );

    }, { passive: true });

    // Mobile Scroll
    let scrollTimeout;

    window.addEventListener("scroll", function () {

        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(function () {

            createFlower(
                Math.random() * window.innerWidth,
                window.innerHeight * 0.75
            );

        }, 20);

    }, { passive: true });

});